/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verification_Security_MessageInputs */

const en_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For security reasons, we need to verify you have access to the email address you entered. Please click the button below to complete the confirmation.`)
};

const id_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk alasan keamanan, kami perlu memverifikasi bahwa Anda memiliki akses ke alamat email yang Anda masukkan. Silakan klik tombol di bawah ini untuk menyelesaikan konfirmasi.`)
};

const ms_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atas sebab keselamatan, kami perlu mengesahkan anda mempunyai akses kepada alamat emel yang anda masukkan. Sila klik butang di bawah untuk melengkapkan pengesahan.`)
};

const ca_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per raons de seguretat, necessitem verificar que tens accés a l'adreça de correu electrònic que has introduït. Si us plau, fes clic al botó a sota per completar la confirmació.`)
};

const cs_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z bezpečnostních důvodů musíme ověřit, že máte přístup k zadané emailové adrese. Klikněte prosím na tlačítko níže, abyste dokončili potvrzení.`)
};

const da_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Af sikkerhedsmæssige årsager skal vi bekræfte, at du har adgang til den e-mailadresse, du har indtastet. Klik venligst på knappen nedenfor for at fuldføre bekræftelsen.`)
};

const de_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Sicherheitsgründen müssen wir überprüfen, ob Sie Zugang zu der eingegebenen E-Mail-Adresse haben. Bitte klicken Sie auf die Schaltfläche unten, um die Bestätigung abzuschließen.`)
};

const et_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turvakaalutlustel peame veenduma, et teil on sisestatud e-posti aadressile juurdepääs. Kinnituse lõpetamiseks klõpsake alloleval nupul.`)
};

const es_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por razones de seguridad, necesitamos verificar que tienes acceso a la dirección de correo electrónico que ingresaste. Haz clic en el botón de abajo para completar la confirmación.`)
};

const fr_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour des raisons de sécurité, nous devons vérifier que vous avez accès à l’adresse e-mail que vous avez saisie. Veuillez cliquer sur le bouton ci-dessous pour confirmer.`)
};

const hr_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iz sigurnosnih razloga, trebamo potvrditi da imate pristup e-mail adresi koju ste unijeli. Molimo kliknite na dugme ispod za dovršavanje potvrde.`)
};

const it_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per motivi di sicurezza, dobbiamo verificare che tu abbia accesso all'indirizzo email che hai inserito. Fai clic sul pulsante qui sotto per completare la conferma.`)
};

const lv_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drošības apsvērumu dēļ mums nepieciešams apstiprināt, ka jums ir pieeja ievadītajai e-pasta adresei. Lūdzu, noklikšķiniet uz pogas zemāk, lai pabeigtu apstiprinājumu.`)
};

const lt_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dėl saugumo priežasčių turime patikrinti, ar turite prieigą prie įvesta el. paštą. Spustelėkite žemiau esantį mygtuką, kad užbaigtumėte patvirtinimą.`)
};

const hu_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biztonsági okokból meg kell erősítenünk, hogy hozzáfér az ön által megadott email címhez. Kérjük, kattintson az alábbi gombra a megerősítés befejezéséhez.`)
};

const nl_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om veiligheidsredenen moeten we verifiëren dat je toegang hebt tot het door jou ingevoerde e-mailadres. Klik hieronder op de knop om de bevestiging te voltooien.`)
};

const nb_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Av sikkerhetsmessige årsaker må vi bekrefte om du har tilgang til e-postadressen du skrev inn. Trykk på knappen nedenfor for å bekrefte dette.`)
};

const pl_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ze względów bezpieczeństwa musimy zweryfikować, czy masz dostęp do podanego adresu e-mail. Kliknij poniższy przycisk, aby zakończyć proces potwierdzania.`)
};

const pt_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por razões de segurança, precisamos verificar se você tem acesso ao endereço de e-mail inserido. Por favor, clique no botão abaixo para concluir a confirmação.`)
};

const ro_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din motive de securitate, trebuie să verificăm că aveți acces la adresa de e-mail introdusă. Vă rugăm să faceți clic pe butonul de mai jos pentru a finaliza confirmarea.`)
};

const sk_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z bezpečnostných dôvodov potrebujeme overiť, či máte prístup k zadanej e-mailovej adrese. Kliknite na tlačidlo nižšie, aby ste dokončili potvrdenie.`)
};

const sl_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaradi varnostnih razlogov moramo preveriti, da imate dostop do vnesenega e-poštnega naslova. Prosimo, kliknite na spodnji gumb za dokončanje potrditve.`)
};

const fi_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turvallisuussyistä meidän on vahvistettava, että sinulla on pääsy syöttämääsi sähköpostiosoitteeseen. Klikkaa alla olevaa painiketta vahvistaaksesi.`)
};

const sv_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Av säkerhetsskäl behöver vi verifiera att du har tillgång till den e-postadress du angav. Vänligen klicka på knappen nedan för att slutföra bekräftelsen.`)
};

const vi_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì lý do bảo mật, chúng tôi cần xác minh bạn có quyền truy cập vào địa chỉ email bạn đã nhập. Vui lòng nhấp vào nút bên dưới để hoàn tất xác nhận.`)
};

const tr_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenlik nedenleriyle, girdiğiniz e-posta adresine erişiminiz olduğunu doğrulamamız gerekiyor. Onaylamayı tamamlamak için lütfen aşağıdaki düğmeye tıklayın.`)
};

const el_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Για λόγους ασφαλείας, πρέπει να επαληθεύσουμε ότι έχετε πρόσβαση στη διεύθυνση email που εισάγατε. Παρακαλούμε κάντε κλικ στο κουμπί παρακάτω για να ολοκληρώσετε την επιβεβαίωση.`)
};

const bg_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По съображения за сигурност, трябва да потвърдим, че имате достъп до въведения имейл адрес. Моля, кликнете върху бутона по-долу, за да завършите потвърждението.`)
};

const ru_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В целях безопасности нам нужно убедиться, что у вас есть доступ к введенному адресу электронной почты. Пожалуйста, нажмите кнопку ниже, чтобы завершить подтверждение.`)
};

const sr_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Из безбедносних разлога, морамо потврдити да имате приступ унетој имејл адреси. Кликните на дугме испод да довршите потврду.`)
};

const uk_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`З міркувань безпеки ми повинні переконатися, що ви маєте доступ до введеної адреси електронної пошти. Натисніть кнопку нижче, щоб завершити підтвердження.`)
};

const ka_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`უსაფრთხოების მიზეზით, გჭირდებათ ვალიდაცია, რომ თქვენს მიერ შეყვანილი მეილის მისამართზე წვდომა გაქვთ. გთხოვთ დააწკაპუნოთ ქვემოთ ღილაკზე ვალიდაციის დასასრულებლად.`)
};

const hi_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुरक्षा कारणों से, हमें यह पुष्टि करनी होगी कि आपके पास जिस ईमेल पते को आपने दर्ज किया है, उस तक पहुंच है। कृपया पुष्टि पूरी करने के लिए नीचे दिए गए बटन पर क्लिक करें।`)
};

const th_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ด้วยเหตุผลด้านความปลอดภัย เราจำเป็นต้องยืนยันว่าคุณมีสิทธิ์เข้าถึงที่อยู่อีเมลที่คุณป้อน โปรดคลิกปุ่มด้านล่างเพื่อทำการยืนยันให้เสร็จสมบูรณ์`)
};

const ko_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안상의 이유로, 입력한 이메일 주소에 접근할 수 있는지 확인해야 합니다. 확인을 완료하려면 아래 버튼을 클릭하세요.`)
};

const zh_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出于安全原因，我们需要验证您是否能访问您输入的电子邮件地址。请点击下方的按钮完成确认。`)
};

const zh_tw_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基於安全考量，我們需要確認您確實能存取所輸入的電子郵件地址。請點擊下方按鈕完成驗證程序。`)
};

const ja_verification_security_message = /** @type {(inputs: Verification_Security_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セキュリティ上の理由から、入力したメールアドレスにアクセスできることを確認する必要があります。確認を完了するには、以下のボタンをクリックしてください。`)
};

/**
* | output |
* | --- |
* | "For security reasons, we need to verify you have access to the email address you entered. Please click the button below to complete the confirmation." |
*
* @param {Verification_Security_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verification_security_message = /** @type {((inputs?: Verification_Security_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verification_Security_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verification_security_message(inputs)
	if (locale === "ms") return ms_verification_security_message(inputs)
	if (locale === "ca") return ca_verification_security_message(inputs)
	if (locale === "cs") return cs_verification_security_message(inputs)
	if (locale === "da") return da_verification_security_message(inputs)
	if (locale === "de") return de_verification_security_message(inputs)
	if (locale === "et") return et_verification_security_message(inputs)
	if (locale === "es") return es_verification_security_message(inputs)
	if (locale === "fr") return fr_verification_security_message(inputs)
	if (locale === "hr") return hr_verification_security_message(inputs)
	if (locale === "it") return it_verification_security_message(inputs)
	if (locale === "lv") return lv_verification_security_message(inputs)
	if (locale === "lt") return lt_verification_security_message(inputs)
	if (locale === "hu") return hu_verification_security_message(inputs)
	if (locale === "nl") return nl_verification_security_message(inputs)
	if (locale === "nb") return nb_verification_security_message(inputs)
	if (locale === "pl") return pl_verification_security_message(inputs)
	if (locale === "pt") return pt_verification_security_message(inputs)
	if (locale === "ro") return ro_verification_security_message(inputs)
	if (locale === "sk") return sk_verification_security_message(inputs)
	if (locale === "sl") return sl_verification_security_message(inputs)
	if (locale === "fi") return fi_verification_security_message(inputs)
	if (locale === "sv") return sv_verification_security_message(inputs)
	if (locale === "vi") return vi_verification_security_message(inputs)
	if (locale === "tr") return tr_verification_security_message(inputs)
	if (locale === "el") return el_verification_security_message(inputs)
	if (locale === "bg") return bg_verification_security_message(inputs)
	if (locale === "ru") return ru_verification_security_message(inputs)
	if (locale === "sr") return sr_verification_security_message(inputs)
	if (locale === "uk") return uk_verification_security_message(inputs)
	if (locale === "ka") return ka_verification_security_message(inputs)
	if (locale === "hi") return hi_verification_security_message(inputs)
	if (locale === "th") return th_verification_security_message(inputs)
	if (locale === "ko") return ko_verification_security_message(inputs)
	if (locale === "zh") return zh_verification_security_message(inputs)
	if (locale === "zh-tw") return zh_tw_verification_security_message(inputs)
	if (locale === "ja") return ja_verification_security_message(inputs)
	return en_verification_security_message(inputs)
});